import { getZombieInstanceFromPrimaryKey } from '@iotv/datamodel-core';
import { matchEntityStates } from '@iotv/entity-state';
import { deviceEnabledTypes } from '@iotv/payload-definition';
const debug = process.env.REACT_APP_DEBUG && false;
/** retrieves all possible entity states for given object type and builds a bucketStrategy map if any entity states define a bucket strategy */
export const getBucketStrategyMap = (selectedObjects) => {
    const objectTypeIds = selectedObjects.reduce((a, c) => {
        const { type } = c;
        if (!a.includes(type)) {
            a.push(type);
        }
        return a;
    }, []);
    const bucketStrategyMap = Object.entries(deviceEnabledTypes)
        .filter(([entityObjectTypeId, deviceTypeMap]) => objectTypeIds.includes(entityObjectTypeId))
        .reduce((a, [entityObjectTypeId, deviceTypeMap]) => {
        const deviceTypes = deviceTypeMap.deviceTypes;
        for (let d of deviceTypes) {
            const device = getZombieInstanceFromPrimaryKey(`Device:XXX`, { deviceType: d.deviceType });
            const entity = getZombieInstanceFromPrimaryKey(`${entityObjectTypeId}:XXX`);
            debug && console.log('deviceType', { d, entity });
            const enitityStateBundles = matchEntityStates({ device, entity });
            enitityStateBundles.forEach((bundle) => {
                debug && console.log('getBucketStrategyMap bundle keys', Object.keys(bundle ?? { noBundle: true }));
                if (bundle?.calculateStateBucketStrategyMap) {
                    Object.assign(a, bundle.calculateStateBucketStrategyMap);
                }
            });
        }
        return a;
    }, {});
    debug && console.log('getBucketStrategyMap', { objectTypeIds, bucketStrategyMap });
    return bucketStrategyMap;
};
export const getBucketStrategyForTypes = (types) => {
    let bucketStrategyMap = {};
    Object.entries(deviceEnabledTypes)
        .filter(([entityObjectTypeId, deviceTypeMap]) => types.includes(entityObjectTypeId))
        .forEach(([typeId, deviceTypeMap]) => {
        const deviceTypes = deviceTypeMap.deviceTypes;
        for (let d of deviceTypes) {
            const device = getZombieInstanceFromPrimaryKey(`Device:XXX`, { deviceType: d.deviceType });
            const entity = getZombieInstanceFromPrimaryKey(`${typeId}:XXX`);
            debug && console.log('deviceType', { d, entity });
            const enitityStateBundles = matchEntityStates({ device, entity });
            enitityStateBundles.forEach((bundle) => {
                debug && console.log('getBucketStrategyMap bundle keys', Object.keys(bundle ?? { noBundle: true }));
                if (bundle?.calculateStateBucketStrategyMap) {
                    bucketStrategyMap[typeId] = bundle.calculateStateBucketStrategyMap;
                }
            });
        }
    });
    return bucketStrategyMap;
};
